import React, { useState } from 'react';
import { ROLES } from '../data/constants';
import { useLanguage } from '../translations/LanguageContext';
import { ScanIcon, SearchIcon } from './Icons';
import QRScanner from './QRScanner';
import QRActionMenu from './QRActionMenu';
import DetailModal from './modals/DetailModal';

function Scan({ user, currency }) {
  const { t } = useLanguage();
  const [input, setInput] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [scannedValue, setScannedValue] = useState(null);
  const [detailItem, setDetailItem] = useState(null);

  const role = ROLES[user.role] || {};

  const handleLookup = () => {
    const sku = input.replace('BIGSTAR:', '').replace(/^https?:\/\/[^?]*\?u(?:nit)?=/i, '').trim().toUpperCase();
    if (!sku) return;
    setScannedValue(sku);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLookup();
  };

  const handleQRScan = (value) => {
    setShowScanner(false);
    const cleaned = value.replace(/^https?:\/\/[^?]*\?u(?:nit)?=/i, '').replace('BIGSTAR:', '').trim();
    setScannedValue(cleaned);
  };

  return (
    <div style={{ maxWidth: 560, margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">
          <div className="card-title"><ScanIcon />{t('scan')}</div>
        </div>
        <div className="card-body" style={{ textAlign: 'center' }}>
          <button
            className="btn btn-primary"
            style={{ width: '100%', padding: '20px 24px', fontSize: 16, marginBottom: 16, borderRadius: 12 }}
            onClick={() => setShowScanner(true)}
          >
            📷 Open QR Scanner
          </button>

          <div style={{ display: 'flex', gap: 10 }}>
            <input className="form-input" placeholder="Or type SKU manually..." value={input}
              onChange={e => setInput(e.target.value)} onKeyDown={handleKeyDown}
              style={{ textAlign: 'center', fontFamily: 'monospace' }} />
            <button className="btn btn-primary" onClick={handleLookup}><SearchIcon /></button>
          </div>

          <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 10 }}>
            Scan a QR code or enter an SKU to look up a unit and take quick actions
          </div>
        </div>
      </div>

      {showScanner && (
        <QRScanner onScan={handleQRScan} onClose={() => setShowScanner(false)} />
      )}

      {scannedValue && (
        <QRActionMenu
          scannedValue={scannedValue}
          user={user}
          onClose={() => setScannedValue(null)}
          onNavigate={(type, item) => {
            setScannedValue(null);
            if (type === 'details' && item) {
              setDetailItem({ ...item, _type: item._dbKey === 'vehicles' ? 'vehicles' : item._dbKey === 'engines' ? 'engines' : 'parts' });
            }
          }}
        />
      )}

      {detailItem && (
        <DetailModal
          item={detailItem}
          type={detailItem._type}
          onClose={() => setDetailItem(null)}
          currency={currency || 'JPY'}
          canPrice={role.canPrice}
          isCustomer={role.isCustomer}
          user={user}
        />
      )}
    </div>
  );
}

export default Scan;
